export default __webpack_public_path__ + "static/BUS_4-ece1cd7d2612515b80f0090c0ae0ca5d.jpg";